import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SearchResultList from './SearchResultList';

const RootContainer = styled.div`
  margin: 16px;
  padding-bottom: 16px;
`;

const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyStateText = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: #484848;
`;

const SearchResultContainer = ({
  type,
  results,
}) => (
  <RootContainer>
    {
      results.length > 0 ? (
        <SearchResultList
          type={type}
          results={results}
        />
      ) : (
        <EmptyStateContainer>
          <EmptyStateText>
            No results found :(
          </EmptyStateText>
        </EmptyStateContainer>
      )
    }
  </RootContainer>
);

SearchResultContainer.propTypes = {
  type: PropTypes.oneOf(['exhibitor', 'webinar']),
  results: PropTypes.arrayOf(PropTypes.shape()),
};

SearchResultContainer.defaultProps = {
  type: 'exhibitor',
  results: [],
};

export default SearchResultContainer;
